import { render } from "./BiotronDiagnosticsPage.vue?vue&type=template&id=173ba8b6&scoped=true"
import script from "./BiotronDiagnosticsPage.vue?vue&type=script&lang=js"
export * from "./BiotronDiagnosticsPage.vue?vue&type=script&lang=js"

import "./BiotronDiagnosticsPage.vue?vue&type=style&index=0&id=173ba8b6&scoped=true&lang=css"

import exportComponent from "../../../../../biotron-pwa-ux-runtime/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-173ba8b6"]])

export default __exports__